import React, { useEffect } from 'react';

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-xl font-bold text-stone-800 dark:text-stone-200 border-l-4 border-amber-700 pl-3">
      {title}
    </h2>
    <div className="text-stone-700 dark:text-stone-300 leading-relaxed space-y-2 pl-1">
      {children}
    </div>
  </section>
);

const Datenschutz = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-stone-50 dark:bg-navy-950 transition-colors duration-300">
      {/* Hero */}
      <div className="bg-brand dark:bg-navy-900 text-white py-16 border-b border-transparent dark:border-navy-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm font-semibold uppercase tracking-widest text-amber-300 mb-2">Rechtliches</p>
          <h1 className="text-4xl md:text-5xl font-serif font-bold mb-3">Datenschutzerklärung</h1>
          <p className="text-stone-300 text-lg">Gemäß DSGVO (EU) 2016/679 · Stand: {new Date().getFullYear()}</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-10">

        <Section title="1. Verantwortlicher">
          <p>
            Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
          </p>
          <address className="not-italic bg-white dark:bg-navy-800 border border-stone-200 dark:border-navy-700 rounded-lg p-5 space-y-1 text-sm">
            <p className="font-bold text-stone-900 dark:text-stone-100">Sören Padel / Liedzeit</p>
            <p>Örträsk 48</p>
            <p>935 93 Norsjö (Schweden)</p>
            <p className="pt-2">E-Mail: <a href="mailto:admin@liedzeit.de" className="text-amber-700 dark:text-amber-400 hover:underline">admin@liedzeit.de</a></p>
            <p>Tel. +46 (0) 7222 61506</p>
          </address>
        </Section>

        <Section title="2. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck ihrer Verwendung">
          <p className="font-semibold text-stone-800 dark:text-stone-200">a) Beim Besuch der Website</p>
          <p>
            Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser automatisch
            Informationen an den Server unserer Website gesendet. Diese Informationen werden temporär in einem sogenannten
            Logfile gespeichert. Folgende Informationen werden dabei ohne Ihr Zutun erfasst und bis zur automatisierten
            Löschung gespeichert:
          </p>
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>IP-Adresse des anfragenden Rechners</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Name und URL der abgerufenen Datei</li>
            <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
            <li>verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der Name Ihres Access-Providers</li>
          </ul>
          <p>
            Die genannten Daten werden durch uns zu folgenden Zwecken verarbeitet: Gewährleistung eines reibungslosen
            Verbindungsaufbaus der Website, Gewährleistung einer komfortablen Nutzung unserer Website, Auswertung der
            Systemsicherheit und -stabilität sowie zu weiteren administrativen Zwecken.
          </p>
          <p>
            Die Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO. Unser berechtigtes Interesse
            folgt aus den oben aufgelisteten Zwecken zur Datenerhebung.
          </p>

          <p className="font-semibold text-stone-800 dark:text-stone-200 pt-2">b) Bei Nutzung unseres Kontaktformulars</p>
          <p>
            Bei Fragen jeglicher Art bieten wir Ihnen die Möglichkeit, mit uns über ein auf der Website bereitgestelltes
            Formular Kontakt aufzunehmen. Dabei ist die Angabe einer gültigen E-Mail-Adresse sowie Ihres Namens erforderlich,
            damit wir wissen, von wem die Anfrage stammt und um diese beantworten zu können. Weitere Angaben können
            freiwillig getätigt werden.
          </p>
          <p>
            Die Datenverarbeitung zum Zwecke der Kontaktaufnahme mit uns erfolgt nach Art. 6 Abs. 1 S. 1 lit. a DSGVO auf
            Grundlage Ihrer freiwillig erteilten Einwilligung. Die für die Benutzung des Kontaktformulars von uns erhobenen
            personenbezogenen Daten werden nach Erledigung der von Ihnen gestellten Anfrage automatisch gelöscht.
          </p>
        </Section>

        <Section title="3. Weitergabe von Daten">
          <p>
            Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im Folgenden aufgeführten Zwecken findet
            nicht statt. Wir geben Ihre persönlichen Daten nur an Dritte weiter, wenn:
          </p>
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>Sie Ihre nach Art. 6 Abs. 1 S. 1 lit. a DSGVO ausdrückliche Einwilligung dazu erteilt haben,</li>
            <li>die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. f DSGVO zur Geltendmachung, Ausübung oder Verteidigung
              von Rechtsansprüchen erforderlich ist und kein Grund zur Annahme besteht, dass Sie ein überwiegendes
              schutzwürdiges Interesse an der Nichtweitergabe Ihrer Daten haben,</li>
            <li>für den Fall, dass für die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. c DSGVO eine gesetzliche
              Verpflichtung besteht,</li>
            <li>dies gesetzlich zulässig und nach Art. 6 Abs. 1 S. 1 lit. b DSGVO für die Abwicklung von
              Vertragsverhältnissen mit Ihnen erforderlich ist.</li>
          </ul>
        </Section>

        <Section title="4. Cookies">
          <p>
            Wir setzen auf unserer Seite ausschließlich technisch notwendige Cookies ein. Dabei handelt es sich um kleine
            Dateien, die Ihr Browser automatisch erstellt und die auf Ihrem Endgerät gespeichert werden, wenn Sie unsere
            Website besuchen.
          </p>
          <p>
            Wir verwenden <strong>localStorage</strong> im Browser ausschließlich, um Ihre Darstellungseinstellung
            (Hell-/Dunkelmodus) zu speichern. Es werden dabei keine personenbezogenen Daten erfasst oder an Dritte
            übermittelt. Sie können diese Einstellung jederzeit über Ihren Browser löschen.
          </p>
          <p>
            Die durch technisch notwendige Cookies verarbeiteten Daten werden nicht zur Erstellung von Nutzerprofilen
            verwendet. Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f DSGVO.
          </p>
        </Section>

        <Section title="5. Betroffenenrechte">
          <p>Sie haben das Recht:</p>
          <ul className="list-disc list-inside space-y-1 pl-2">
            <li>gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen;</li>
            <li>gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns
              gespeicherten personenbezogenen Daten zu verlangen;</li>
            <li>gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen,
              soweit nicht die Verarbeitung zur Ausübung des Rechts auf freie Meinungsäußerung und Information, zur
              Erfüllung einer rechtlichen Verpflichtung, aus Gründen des öffentlichen Interesses oder zur
              Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist;</li>
            <li>gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen;</li>
            <li>gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem
              strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder die Übermittlung an einen anderen
              Verantwortlichen zu verlangen;</li>
            <li>gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen;</li>
            <li>gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren. In der Regel können Sie sich
              hierfür an die Aufsichtsbehörde Ihres üblichen Aufenthaltsortes oder Arbeitsplatzes oder unseres
              Unternehmenssitzes wenden.</li>
          </ul>
        </Section>

        <Section title="6. Widerspruchsrecht">
          <p>
            Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß Art. 6 Abs. 1 S. 1
            lit. f DSGVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DSGVO Widerspruch gegen die
            Verarbeitung Ihrer personenbezogenen Daten einzulegen, soweit dafür Gründe vorliegen, die sich aus
            Ihrer besonderen Situation ergeben oder sich der Widerspruch gegen Direktwerbung richtet.
          </p>
          <p>
            Im letzteren Fall haben Sie ein generelles Widerspruchsrecht, das ohne Angabe einer besonderen Situation
            von uns umgesetzt wird.
          </p>
          <p>
            Möchten Sie von Ihrem Widerrufs- oder Widerspruchsrecht Gebrauch machen, genügt eine E-Mail an{' '}
            <a href="mailto:admin@liedzeit.de" className="text-amber-700 dark:text-amber-400 hover:underline">
              admin@liedzeit.de
            </a>.
          </p>
        </Section>

        <Section title="7. Datensicherheit">
          <p>
            Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) in
            Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird.
            In der Regel handelt es sich dabei um eine 256-Bit-Verschlüsselung. Falls Ihr Browser keine
            256-Bit-Verschlüsselung unterstützt, greifen wir stattdessen auf 128-Bit-v3-Technologie zurück.
          </p>
          <p>
            Ob eine einzelne Seite unseres Internetauftrittes verschlüsselt übertragen wird, erkennen Sie an der
            geschlossenen Darstellung des Schüssel- beziehungsweise Schloss-Symbols in der unteren Statusleiste
            Ihres Browsers.
          </p>
          <p>
            Wir bedienen uns im Übrigen geeigneter technischer und organisatorischer Sicherheitsmaßnahmen, um Ihre
            Daten gegen zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust,
            Zerstörung oder gegen den unbefugten Zugriff Dritter zu schützen. Unsere Sicherheitsmaßnahmen werden
            entsprechend der technologischen Entwicklung fortlaufend verbessert.
          </p>
        </Section>

        <Section title="8. Hosting">
          <p>
            Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten,
            die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann
            es sich v.a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten,
            Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden,
            handeln.
          </p>
          <p>
            Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und
            bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und
            effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter
            (Art. 6 Abs. 1 lit. f DSGVO).
          </p>
        </Section>

        <Section title="9. Aktualität und Änderung dieser Datenschutzerklärung">
          <p>
            Diese Datenschutzerklärung ist aktuell gültig und hat den Stand {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}.
          </p>
          <p>
            Durch die Weiterentwicklung unserer Website und Angebote darüber oder aufgrund geänderter gesetzlicher
            beziehungsweise behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern.
            Die jeweils aktuelle Datenschutzerklärung kann jederzeit auf der Website unter{' '}
            <a href="/dsgvo" className="text-amber-700 dark:text-amber-400 hover:underline">
              www.liedzeit.de/dsgvo
            </a>{' '}
            von Ihnen abgerufen und ausgedruckt werden.
          </p>
        </Section>

        <div className="mt-12 pt-8 border-t border-stone-200 dark:border-navy-700 text-sm text-stone-500 dark:text-stone-400">
          <p>Sören Padel / Liedzeit · Norsjö, Schweden · <a href="mailto:admin@liedzeit.de" className="hover:text-amber-700 dark:hover:text-amber-400">admin@liedzeit.de</a></p>
        </div>

      </div>
    </div>
  );
};

export default Datenschutz;
